﻿import NativejsSelect from "nativejs-select";
import SimpleBar from "simplebar";
import { getTranslations } from "./translations";

// Default is 767
const windowMedia = (maxWidth: number = 767) =>
{
    return typeof (window.matchMedia) === "function" && window.matchMedia(`only screen and (max-width: ${maxWidth}px)`).matches;
}

const processMarkedForRemove = () =>
{
    $(".marked-for-remove").parent().css("padding-top", "");
    $(".marked-for-remove").remove();
}

let smoothReplaceItemsToHandle = 0;

const replaceContentSmooth = async (contentBlock, newBlockContent, forceNoLazyLoad, customWidth = null) =>
{
    // Add an item to handle. Prevents events from being set until all of these are done.
    smoothReplaceItemsToHandle++;

    if (forceNoLazyLoad)
    {
        // Ensure no lazy load is active.
        newBlockContent = newBlockContent
            .replaceAll("loading=\"lazy\"", "")
            .replaceAll("data-src", "src");
    }

    // Get amount of images present.
    var imageCount = $(contentBlock + " img").length;

    if (imageCount > 0)
    {
        var isLoaded = false;
        var loadedCount = 0;
        await new Promise<void>((resolve) =>
        {
            // Loop all images and load them.
            $(contentBlock + " img").each(function (index, item)
            {
                var img = new Image();

                var imgSrc = $(item).attr("src");
                // Fallback to data-src if no src was present.
                if (!imgSrc)
                    imgSrc = $(item).data("src");
                // Fallback to empty image if none found. Should never come this far though.
                if (!imgSrc)
                    imgSrc = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

                img.src = imgSrc;

                // Give images a short time to complete loading.
                var intervalCurrentTryCount = 0;
                var intervalMaxTryCount = 5;
                var intervalDelay = 1;

                var interval = setInterval(async function ()
                {
                    // Image load is complete, or the max try count was reached.
                    if (img.complete ||
                        intervalCurrentTryCount >= intervalMaxTryCount)
                    {
                        clearInterval(interval);

                        loadedCount++;

                        // Replace the content once all images are loaded.
                        if (loadedCount >= imageCount &&
                            !isLoaded)
                        {
                            isLoaded = true;
                            await applyReplaceContentSmooth(contentBlock, newBlockContent, customWidth);
                            resolve();
                        }
                    }
                    else
                        intervalCurrentTryCount++;
                }, intervalDelay);
            });
        });
    }
    // No images present; immediately replace.
    else
        await applyReplaceContentSmooth(contentBlock, newBlockContent, customWidth);
}

const applyReplaceContentSmooth = async (contentBlock, newBlockContent, customWidth) =>
{
    // Explicitly set the block's height.
    $(contentBlock).height($(contentBlock).height());

    // Ensure all items that should be deleted, are.
    $(contentBlock + " .marked-for-remove").remove();

    if ($(contentBlock).length > 0 &&
        $(contentBlock).html().length > 0)
    {
        var firstChild = $(contentBlock).children()[0];
        var marginTop = 0;

        if ($(firstChild).css("display") !== "none" &&
            $(firstChild).outerHeight(false) > 0)
        {
            marginTop = parseInt($(firstChild).css("margin-top"));
            if (isNaN(marginTop))
                marginTop = 0;
        }

        // Ensure first child element has no margin-top.
        $(contentBlock + " > *:first-child").css("margin-top", 0);

        // Allow giving custom width for block in case of scroll bars.
        var width = customWidth;
        if (typeof (width) === typeof (undefined) || width == null)
            width = $(contentBlock).width();

        // Wrap content in a temporary div to overlay on the new content.
        $(contentBlock).wrapInner(`<div class="marked-for-remove" style="position: absolute; z-index: 2; height: ${$(contentBlock).height()}px; width: ${width}px; background-color: #ffffff;"></div>`);
        if (marginTop > 0)
            $(contentBlock).css("padding-top", marginTop);
    }

    // Add the new content.
    $(contentBlock).append(newBlockContent);

    // Remove the explicit height.
    $(contentBlock).height("");

    // Remove an item to handle. Allows events to be set once all of these are done.
    smoothReplaceItemsToHandle--;
};

const initSimpleBar = (element?: string | null) =>
{
    if (!element)
        element = ".custom-select-item-wrapper.simplebar-select .nativejs-select__options";

    if ($(element).length > 0)
    {
        $(element).each(function (index, item)
        {
            new SimpleBar(item,
                {
                    autoHide: false
                }
            );
        });
    }
};

const initNativeSelect = () =>
{
    if (typeof (NativejsSelect) !== typeof (undefined))
    {
        var selector = ".custom-select-item, .select-holder select";

        refreshSelectOptions();
        $(selector).each(function ()
        {
            if ($(this).find("option").length == 0)
                $(this).append("<option selected=\"selected\"></option>");
        });

        try
        {
            new NativejsSelect({
                selector: selector,
                renderOptions: (option) =>
                {
                    const icon = option.getAttribute("data-icon");
                    const alt = option.getAttribute("data-alt");
                    const textSpan = option.parentElement.classList.contains("custom-select-text-span");

                    const imageTemplate = icon ? `<img class="lazy" src="${icon}" alt="${alt}" width="20" fetchpriority=\"low\" />` : "";
                    const textTemplate = textSpan ? `<span title="${option.textContent}">${option.textContent}</span>` : option.textContent;
                    return imageTemplate + textTemplate;
                }
            });
        }
        catch { }

        $(selector).each(function ()
        {
            var select = $(this);
            var customSelect = $(this).next();
            var customSelectOption = $(customSelect).find(".nativejs-select__options");
            $(select).each(function ()
            {
                if ($(select).find("option").length == 1)
                {
                    $(customSelect).addClass("disabled");
                    $(customSelect).off("click");
                }

                $(this).find("option").each(function ()
                {
                    var optionClass = $(this).attr("class");
                    var optionText = $(this).text();
                    $(customSelectOption).find("button").each(function ()
                    {
                        if ($(this).text().trim() === optionText)
                            $(this).addClass(optionClass);
                    });
                });
            });
        });

        $(".select-holder").addClass("initialized");
    }
}

const refreshSelectOptions = () =>
{
    $(".custom-select").each(function ()
    {
        if ($(this).find("option").length > 0)
            $(this).addClass("custom-select-item");
        else
            $(this).removeClass("custom-select-item");
    });
}

const formatPrice = (price, addCurrency) =>
{
    var formattedPrice = "";

    if (typeof (price) === "number")
    {
        var priceParts = price.toString().replace(".", ",").split(",");

        if (priceParts.length > 0)
        {
            var currencyPart = "";
            if (addCurrency)
                currencyPart = getTranslations().priceFormatCurrency;

            if (priceParts.length > 1)
            {
                var cents = priceParts[1];
                if (cents.length < 2)
                    cents += "0";

                formattedPrice = String.format(getTranslations().priceFormat, currencyPart, priceParts[0], cents).trim();
            }
            else
                formattedPrice = String.format(getTranslations().priceFormatWhole, currencyPart, priceParts[0]).trim();
        }
    }

    return formattedPrice;
};

const dateIsEqual = (a: Date, b: Date): boolean =>
{
    if (a.getDate() != b.getDate())
        return false;

    if (a.getMonth() != b.getMonth())
        return false;

    if (a.getFullYear() != b.getFullYear())
        return false;

    return true;
};

const arrayContains = function <T>(this: T[], item: T): boolean
{
    // Per spec, the way to identify NaN is that it is not equal to itself
    const findNaN = item !== item;
    let indexOf: (this: T[], searchElement: T) => number;

    if (!findNaN && typeof Array.prototype.indexOf === "function")
        indexOf = Array.prototype.indexOf;
    else
    {
        indexOf = function (this: T[], targetItem: T): number
        {
            let index = -1;

            for (let i = 0; i < this.length; i++)
            {
                const currentItem = this[i];

                if ((findNaN && currentItem !== currentItem) || currentItem === targetItem)
                {
                    index = i;
                    break;
                }
            }

            return index;
        };
    }

    return indexOf.call(this, item) > -1;
};

const removeURLParameter = (url: string, parameter: string) =>
{
    try
    {
        const parsedUrl = new URL(url, window.location.origin);

        if (parsedUrl.searchParams.has(parameter))
        {
            parsedUrl.searchParams.delete(parameter);

            if (!url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("//"))
                return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;

            return parsedUrl.toString();
        }
    }
    catch (e)
    {
        if (url.includes("?"))
        {
            const [pathAndQuery, hash] = url.split("#");
            const [path, query] = pathAndQuery.split("?");
            const params = new URLSearchParams(query);

            params.delete(parameter);

            const newQuery = params.toString();
            const rebuiltHash = hash ? "#" + hash : "";

            return path + (newQuery ? "?" + newQuery : "") + rebuiltHash;
        }
    }

    return url;
}

const getUrlVars = () =>
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('/') + 1).split('/');
    for (var i = 0; i < hashes.length; i++)
    {
        vars.push(hashes[i]);
        vars[hashes[i]] = hashes[i + 1];
    }
    return vars;
};

const getUrlVar = (name) =>
{
    return getUrlVars()[name];
};

const getQueryStringValue = (url, key) =>
{
    var vars = [], hash;

    if (url == undefined || url == null)
        return null;

    var hashes = url.slice(url.indexOf('/') + 1).split('/');

    for (var i = 0; i < hashes.length; i++)
    {
        vars.push(hashes[i]);
        vars[hashes[i]] = hashes[i + 1];
    }

    return vars[key];
};

const getParameterByName = (name) =>
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

const performClickOnKeyboardInteraction = (e) =>
{
    if (e.keyCode == 13 || e.keyCode == 32)
    { // Enter or spacebar
        $(this).trigger("click");
        e.stopPropagation();
    }
};

const refreshKeyboardInteractions = () =>
{
    $(".keyboard-clickable").off("keydown", performClickOnKeyboardInteraction);
    $(".keyboard-clickable").on("keydown", performClickOnKeyboardInteraction);
};

const getIdentifierFromData = (item: HTMLElement, dataKey: string) =>
{
    let identifier = 0;
    if ($(item).length > 0 && dataKey.length > 0)
    {
        const dataAttribute = $(item).data(dataKey) as string;

        if (dataAttribute)
            identifier = parseInt(dataAttribute);
    }

    return identifier;
}

export
{
    processMarkedForRemove,
    replaceContentSmooth,
    windowMedia,
    smoothReplaceItemsToHandle,
    formatPrice,
    dateIsEqual,
    arrayContains,
    initSimpleBar,
    initNativeSelect,
    refreshSelectOptions,
    removeURLParameter,
    getUrlVar,
    getUrlVars,
    getParameterByName,
    getQueryStringValue,
    refreshKeyboardInteractions,
    getIdentifierFromData
};